import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';

const timelineEvents = [
  { year: '2024', title: '平台创立', description: '内容导航平台正式成立，以"让内容发现更简单"为使命，开启了内容分类导航服务的新篇章。' },
  { year: '2025', title: '快速发展', description: '内容分区从最初的3个扩展到5个核心分区，文章数量突破50篇，月活跃用户达到20万。' },
  { year: '2025', title: '技术升级', description: '完成平台技术架构升级，引入智能内容推荐算法，大幅提升用户体验和内容匹配精准度。' },
  { year: '2026', title: '品牌升级', description: '月活跃用户突破50万，内容覆盖范围进一步扩大，成为国内领先的内容分区导航平台之一。' },
];

const teamMembers = [
  { name: '张明远', role: '创始人 & CEO', description: '10年互联网产品经验，前知名内容平台产品总监', avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20portrait%20with%20warm%20lighting%2C%20business%20casual%20attire%2C%20confident%20expression%2C%20clean%20studio%20background%2C%20corporate%20headshot%20style&width=200&height=200&seq=team-member-1&orientation=squarish' },
  { name: '李思涵', role: '内容总监', description: '资深媒体人，曾任多家主流媒体内容主编', avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%20with%20warm%20lighting%2C%20elegant%20business%20attire%2C%20friendly%20smile%2C%20clean%20studio%20background%2C%20corporate%20headshot%20style&width=200&height=200&seq=team-member-2&orientation=squarish' },
  { name: '王浩然', role: '技术负责人', description: '全栈工程师，在推荐算法和大数据处理领域有丰富经验', avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20portrait%20with%20warm%20lighting%2C%20casual%20tech%20attire%2C%20thoughtful%20expression%2C%20clean%20studio%20background%2C%20corporate%20headshot%20style&width=200&height=200&seq=team-member-3&orientation=squarish' },
  { name: '赵晓雨', role: '运营总监', description: '5年内容社区运营经验，擅长用户增长和社区建设', avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%20with%20warm%20lighting%2C%20modern%20business%20attire%2C%20warm%20smile%2C%20clean%20studio%20background%2C%20corporate%20headshot%20style&width=200&height=200&seq=team-member-4&orientation=squarish' },
];

export default function AboutPage() {
  return (
    <>
      <SEOHead
        title="关于我们 - 内容导航平台 | 品牌介绍与联系方式"
        description="内容导航平台致力于为用户提供优质的内容分类导航服务。了解更多关于我们的品牌故事、团队介绍、平台信誉及联系方式。覆盖科技数码、影视娱乐、生活百科、教育学习、健康养生等分区。"
        keywords="关于我们,品牌介绍,团队介绍,联系方式,内容导航,内容平台,平台信誉"
        canonicalUrl={window.location.origin + (__BASE_PATH__ || '') + '/about'}
      />
      <SchemaOrg
        type="Organization"
        data={{
          name: '内容导航平台',
          url: window.location.origin + (__BASE_PATH__ || ''),
          description: '为用户提供优质内容分类导航服务的内容聚合平台',
          email: 'contact@contentnav.cn',
          telephone: '+86-400-888-9999',
          address: {
            '@type': 'PostalAddress',
            streetAddress: '科技园路88号',
            addressLocality: '北京市',
            addressRegion: '朝阳区',
            addressCountry: 'CN',
          },
        }}
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: '首页',
              item: window.location.origin + (__BASE_PATH__ || '') + '/',
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: '关于我们',
            },
          ],
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-16">
          {/* Page Header */}
          <section className="bg-background-100/50 border-b border-background-200/70">
            <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 md:py-12">
              <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />
              <h1 className="text-2xl md:text-4xl font-bold text-foreground-950 mt-2" style={{ fontFamily: 'var(--font-heading)' }}>
                关于我们
              </h1>
              <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-2xl">
                了解我们的品牌故事、发展历程和核心团队
              </p>
            </div>
          </section>

          {/* Brand Introduction */}
          <section className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
            <div className="flex flex-col lg:flex-row gap-10 items-center">
              <div className="lg:w-1/2">
                <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                  品牌故事
                </h2>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                  内容导航平台创立于2024年，是国内领先的内容分区导航服务平台。我们致力于解决用户在信息过载时代面临的内容发现难题——面对海量的信息，用户往往不知道从何看起，也难以快速找到真正感兴趣的内容。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                  我们的核心理念是<strong>"让内容发现更简单"</strong>。通过对海量内容进行科学分类和智能推荐，我们将内容按照科技数码、影视娱乐、生活百科、教育学习、健康养生五大核心领域进行整理，让用户能够像逛书店一样，轻松浏览和发现自己感兴趣的内容分区。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  截至目前，平台已累计收录超过90篇精选文章，服务超过50万月活跃用户。我们的内容团队持续不断地筛选和整理优质内容，确保用户每次访问都能发现新的、有价值的阅读材料。
                </p>
              </div>
              <div className="lg:w-1/2 w-full">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20workspace%20with%20creative%20team%20collaboration%2C%20warm%20natural%20lighting%2C%20wooden%20furniture%2C%20inspirational%20atmosphere%2C%20clean%20contemporary%20design%2C%20professional%20environment&width=700&height=500&seq=about-brand&orientation=landscape"
                  alt="内容导航平台办公环境"
                  className="w-full h-auto rounded-lg"
                  title="内容导航平台 - 办公环境"
                />
              </div>
            </div>
          </section>

          {/* Timeline */}
          <section className="bg-background-100/50 py-12 md:py-16">
            <div className="max-w-4xl mx-auto px-4 md:px-6">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 text-center mb-10" style={{ fontFamily: 'var(--font-heading)' }}>
                发展历程
              </h2>
              <div className="relative">
                <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-background-200"></div>
                <div className="flex flex-col gap-8">
                  {timelineEvents.map((event, index) => (
                    <div key={index} className={`relative flex items-start gap-6 ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                      <div className="hidden md:block md:w-1/2"></div>
                      <div className="absolute left-4 md:left-1/2 -translate-x-1/2 w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center z-10">
                        <i className="ri-check-line text-white text-sm"></i>
                      </div>
                      <div className="ml-12 md:ml-0 md:w-1/2 bg-background-50 rounded-lg border border-background-200/70 p-5">
                        <span className="text-xs font-semibold text-primary-500">{event.year}</span>
                        <h3 className="text-sm font-semibold text-foreground-950 mt-1">{event.title}</h3>
                        <p className="text-xs text-foreground-600 mt-2 leading-relaxed">{event.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* Stats */}
          <section className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 text-center mb-10" style={{ fontFamily: 'var(--font-heading)' }}>
              平台信誉
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <div className="text-center p-6 bg-background-50 rounded-lg border border-background-200/70">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-shield-check-line text-xl text-accent-900"></i>
                </div>
                <div className="text-2xl md:text-3xl font-bold text-accent-500">99.9%</div>
                <p className="text-xs text-foreground-600 mt-1">服务可用率</p>
              </div>
              <div className="text-center p-6 bg-background-50 rounded-lg border border-background-200/70">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-user-heart-line text-xl text-primary-900"></i>
                </div>
                <div className="text-2xl md:text-3xl font-bold text-primary-500">50万+</div>
                <p className="text-xs text-foreground-600 mt-1">服务用户数</p>
              </div>
              <div className="text-center p-6 bg-background-50 rounded-lg border border-background-200/70">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-article-line text-xl text-secondary-900"></i>
                </div>
                <div className="text-2xl md:text-3xl font-bold text-secondary-500">90+</div>
                <p className="text-xs text-foreground-600 mt-1">精选文章数</p>
              </div>
              <div className="text-center p-6 bg-background-50 rounded-lg border border-background-200/70">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-star-line text-xl text-accent-900"></i>
                </div>
                <div className="text-2xl md:text-3xl font-bold text-accent-500">4.9/5</div>
                <p className="text-xs text-foreground-600 mt-1">用户满意度</p>
              </div>
            </div>
          </section>

          {/* Team */}
          <section className="bg-background-100/50 py-12 md:py-16">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 text-center mb-10" style={{ fontFamily: 'var(--font-heading)' }}>
                核心团队
              </h2>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
                {teamMembers.map((member, index) => (
                  <div key={index} className="text-center">
                    <div className="w-20 h-20 md:w-24 md:h-24 mx-auto mb-4 rounded-full overflow-hidden bg-background-200">
                      <img src={member.avatar} alt={member.name} className="w-full h-full object-cover" title={member.name} />
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-950">{member.name}</h3>
                    <p className="text-xs text-primary-500 font-medium mt-0.5">{member.role}</p>
                    <p className="text-xs text-foreground-600 mt-2 leading-relaxed">{member.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Contact */}
          <section className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 text-center mb-10" style={{ fontFamily: 'var(--font-heading)' }}>
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-xl text-primary-900"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-2">电子邮箱</h3>
                <a href="mailto:contact@contentnav.cn" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  contact@contentnav.cn
                </a>
              </div>
              <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-phone-line text-xl text-accent-900"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-2">客服电话</h3>
                <a href="tel:400-888-9999" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  400-888-9999
                </a>
              </div>
              <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-map-pin-line text-xl text-secondary-900"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-2">公司地址</h3>
                <p className="text-sm text-foreground-600">
                  北京市朝阳区科技园路88号
                </p>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}